import { useEffect, useState } from "react";
import { useStore } from "../../store";
import { observer } from "mobx-react-lite";
import { FaBars } from "react-icons/fa";
import { BiWifi, BiWifiOff } from "react-icons/bi";
import { MdOutlineWbSunny } from "react-icons/md";
import moment from "moment-timezone";
import WifiConnectingIcon from "../../components/WifiConnectingIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { RouterData } from "../../utils/route";

import { icon_cooler, icon_fans, icon_heater, icon_running, icon_defroster, icon_humidity } from "../../assets";
import FanButton from "../../components/FanButton";
import { toJS } from "mobx";

function Header() {
  const { dataStore } = useStore();
  //按钮按下
  const [isPressed, setIsPressed] = useState(false);
  const resData = dataStore.resData;
  // console.log('11111111', 'resData', toJS(resData))
  const timezone = resData.loadSettingAck?.timeZone || '+08:00'
  const twentyFourHourTimeEnabled =
    resData.loadSettingAck?.twentyFourHourTimeEnabled || false;

  const dateFormat = resData.loadSettingAck?.dateFormat || 'DD.MM.YYYY'

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    const pathname = location.pathname as RouterData["path"];

    setIsPressed(pathname.includes("menu"));

    switch (pathname) {
      case "/":
        {
          switch (resData.activeLogAck?.state) {
            case "DIAGNOSTIC":
              {
                dataStore.setNav({ title: "CHAMBER DIAGNOSTICS" });
              }
              break;
            case "ACTIVE":
              {
                dataStore.setNav({ title: "Running..." });
              }
              break;
            case "DRAFT":
              {
                dataStore.setNav({ title: "Easy Ferment" });
              }
              break;

            case "EDITING":
              {
                dataStore.setNav({ title: "Editing" });
              }
              break;
            case "FINISHED":
              {
                dataStore.setNav({ title: "Finished" });
              }
              break;
          }
        }
        break;
      case "/menu-recipe":
        {
          dataStore.setNav({ title: "Recipes" });
        }
        break;
      case "/menu":
        {
          dataStore.setNav({ title: "Menu" });
        }
        break;
      case "/menu-log":
        {
          dataStore.setNav({ title: "Logs" });
        }
        break;

      case "/menu-program":
        {
          dataStore.setNav({ title: "Program" });
        }
        break;
      case "/menu-setting":
        {
          dataStore.setNav({ title: "Settings" });
        }
        break;
      case "/menu-light-setting":
        {
          dataStore.setNav({ title: "Light Settings" });
        }
        break;
      default: {
        dataStore.setNav({ title: "Easy Ferment" });
      }
    }
  }, [location, resData.activeLogAck?.state,]);

  const toggleLight = () => {
    dataStore.sendData({
      action: "toggleLight",
      data: {
        open: !resData.loadNavStatusAck?.light,
      },
    });
  };


  const toggleFans = (open: boolean) => {
    dataStore.sendData({
      action: "toggleFans",
      data: {
        open,
      },
    });
  };

  const updateSetting = (key: string, value: any) => {
    dataStore.sendData({
      action: "updateSetting",
      data: {
        key,
        value,
      }
    });
  };



  useEffect(() => {
    switch (resData.activeLogAck?.state) {
      case "ACTIVE":
        {
          dataStore.setNav({ title: "Running..." });
        }
        break;
      case "DRAFT":
        {
          dataStore.setNav({ title: "Easy Ferment" });
          // 从 diagnostics 或 finished 回到草稿态时，把运行期缓存一起清掉，避免后续 step1 沿用旧数据。
          dataStore.clearData('runProgramProgressAck')
          dataStore.clearData('runProgramTemperatureAck')
          dataStore.clearData('runProgramRecordChartAck')
        }
        break;

      case "EDITING":
        {
          dataStore.setNav({ title: "Editing" });
        }
        break;
      case "FINISHED":
        {
          dataStore.setNav({ title: "Finished" });
        }
        break;
    }
  }, [resData.activeLogAck?.state]);


  const deviceIcons = [
    ...(resData.loadNavStatusAck?.heater ? [{ url: icon_heater, id: 'heater' }] : []),
    ...(resData.loadNavStatusAck?.fans ? [{ url: icon_fans, id: 'fans' }] : []),
    ...(resData.loadNavStatusAck?.defroster ? [{ url: icon_defroster, id: 'defroster' }] : []),
    ...(resData.loadNavStatusAck?.cooler ? [{ url: icon_cooler, id: 'cooler' }] : []),
    ...(resData.loadNavStatusAck?.humidifier ? [{ url: icon_humidity, id: 'humidifier' }] : []),
    ...(resData.activeLogAck?.state === 'ACTIVE' ? [{ url: icon_running, id: 'run' }] : []),
  ];

  /**
   * 获取风扇速度级别
   */
  const getFanSpeedLevel = () => {
    return resData.loadSettingAck?.fanSpeedMode === 'HIGH'
      ? 'Hi'
      : resData.loadSettingAck?.fanSpeedMode === 'LOW'
        ? 'Lo'
        : resData.loadSettingAck?.fanSpeedMode === 'MEDIUM'
          ? 'Me'
          : 'Mi'
  }

  return (
    <div
      className="h-[70px] bg-[#EF8100] flex"
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <div
        className="flex"
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginLeft: 16,
          width: '20%',
        }}
      >
        <div
          onClick={() => {
            if (isPressed) {
              navigate("/")
            } else if (resData.activeLogAck?.state !== 'EDITING') {
              navigate("/menu");
            }
          }}
        >
          <FaBars
            className="bg-quickStartPrimaryBgColor"
            style={{
              color: "white",
              fontSize: 50,
              padding: 5,
              boxShadow: isPressed
                ? "inset 5px 5px 5px rgba(0, 0, 0, 0.25)"
                : undefined,
            }}
          />
        </div>

        <div onClick={toggleLight}>
          <MdOutlineWbSunny
            className="bg-quickStartPrimaryBgColor"
            style={{
              color: `rgba(255,255,255,${resData.loadNavStatusAck?.light ? 1 : 0.2
                })`,
              fontSize: 50,
              padding: 5,
              borderRadius: 50,
              marginLeft: 16,
            }}
          />
        </div>
        <FanButton
          fanSpeedMode={resData.loadSettingAck?.fanSpeedMode}
          fanSwitch={resData.loadNavStatusAck?.fans}
          onFanSpeed={(data) => {
            updateSetting('fanSpeedMode', data)
            setTimeout(() => {
              toggleFans(!!resData.loadNavStatusAck?.fans)
            }, 100);
          }}
          onFanSwitch={(data) => {
            toggleFans(!!data)
          }}

        />

      </div>

      <div
        style={{
          textAlign: "center",
          fontSize: 36,
          fontWeight: "700",
          color: "white",
          width: '40%',
        }}
      >
        {resData.nav?.title}
      </div>

      <div
        className="flex"
        style={{
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          marginRight: 16,
          width: '40%',
        }}
      >
        {deviceIcons.length ? (
          <div
            className="flex"
            style={{
              backgroundColor: "white",
              flexDirection: "row",
              justifyItems: "center",
              borderRadius: 100,
              paddingLeft: 10,
              paddingRight: 10,
              marginRight: 10,
            }}
          >
            {deviceIcons.map((item, index) => (
              <div
                key={index}
                style={{
                  position: 'relative'
                }}
              >
                <img
                  src={item.url}
                  style={{
                    color: "rgba(0,0,0,0.7)",
                    padding: 5,
                    height: 40,
                    width: 40,
                  }}
                />
                <div
                  className="flex"
                  style={{
                    position: 'absolute',
                    left: 27,
                    top: 24,
                    fontWeight: '500',
                    fontSize: 10
                  }}
                >
                  {item.id === 'fans' ? getFanSpeedLevel() : ''}
                </div>
              </div>
            ))}
          </div>
        ) : undefined}

        <div
          style={{
            textAlign: "center",
            fontSize: 24,
            fontWeight: "700",
            color: "white",
          }}
        >
          {moment()
            .utc()
            .utcOffset(timezone)
            .format(
              twentyFourHourTimeEnabled ? `H:mm ${dateFormat}` : `h:mma ${dateFormat}`
            )}
        </div>

        {(() => {
          let wifiStatus = resData.loadNavWifiStatusAck?.wifiStatus;
          switch (wifiStatus) {
            case "CONNECTED": {
              return (
                <BiWifi
                  style={{
                    color: "white",
                    fontSize: 50,
                    padding: 5,
                    marginLeft: 16,
                  }}
                />
              );
            }

            case "NOT_CONNECT":
            default: {
              return (
                <BiWifiOff
                  style={{
                    color: "white",
                    fontSize: 50,
                    padding: 5,
                    marginLeft: 16,
                  }}
                />
              );
            }
            case "CONNECTING": {
              return (
                <WifiConnectingIcon
                  style={{
                    color: "white",
                    fontSize: 50,
                    padding: 5,
                    marginLeft: 16,
                  }}
                />
              );
            }
          }
        })()}
      </div>
    </div>
  );
}
export default observer(Header);
